/**
 * Equipment Master Tab Component
 * Displays equipment list with CRUD operations
 */
import { Truck, File, Edit, Archive, Trash2, Clock } from "lucide-react";
import { readingTypeLabel } from "./readingType";

const EquipmentMasterTab = ({
  equipment,
  isMasterAdmin,
  onEdit,
  onDelete,
  onViewDocuments,
  onArchive,
  onViewLogHistory
}) => {
  return (
    <div className="stat-card overflow-x-auto">
      <table className="w-full">
        <thead>
          <tr className="border-b-2 border-slate-300">
            <th className="text-left py-3 px-4 text-xs uppercase tracking-widest text-slate-700 font-medium">Equipment</th>
            <th className="text-left py-3 px-4 text-xs uppercase tracking-widest text-slate-700 font-medium">Reg/ID</th>
            <th className="text-left py-3 px-4 text-xs uppercase tracking-widest text-slate-700 font-medium">Type</th>
            <th className="text-left py-3 px-4 text-xs uppercase tracking-widest text-slate-700 font-medium">Make/Model</th>
            <th className="text-center py-3 px-4 text-xs uppercase tracking-widest text-slate-700 font-medium">Fuel</th>
            <th className="text-center py-3 px-4 text-xs uppercase tracking-widest text-slate-700 font-medium">Readings</th>
            <th className="text-right py-3 px-4 text-xs uppercase tracking-widest text-slate-700 font-medium">Hours</th>
            <th className="text-right py-3 px-4 text-xs uppercase tracking-widest text-slate-700 font-medium">Fuel Used</th>
            <th className="text-center py-3 px-4 text-xs uppercase tracking-widest text-slate-700 font-medium">Status</th>
            {isMasterAdmin && <th className="text-center py-3 px-4 text-xs uppercase tracking-widest text-slate-700 font-medium">Actions</th>}
          </tr>
        </thead>
        <tbody>
          {equipment.map((eq) => (
            <tr key={eq.id} className="border-b border-slate-200 hover:bg-slate-50" data-testid={`equipment-row-${eq.id}`}>
              <td className="py-3 px-4 font-medium text-primary">{eq.name}</td>
              <td className="py-3 px-4 font-mono text-sm">{eq.equipment_id}</td>
              <td className="py-3 px-4 text-sm">{eq.equipment_type}</td>
              <td className="py-3 px-4 text-sm">{eq.make} {eq.model}</td>
              <td className="py-3 px-4 text-center text-sm">{eq.fuel_type}</td>
              <td className="py-3 px-4 text-center"><span className="px-2 py-1 rounded-sm text-xs font-medium bg-slate-100 text-slate-700 whitespace-nowrap" data-testid={`reading-type-${eq.id}`}>{readingTypeLabel(eq)}</span></td>
              <td className="py-3 px-4 text-right font-mono text-sm font-semibold">{(eq.total_hours || 0).toFixed(1)}</td>
              <td className="py-3 px-4 text-right font-mono text-sm text-warning">{(eq.total_fuel_consumed || 0).toFixed(0)} L</td>
              <td className="py-3 px-4 text-center">
                <span className={`px-2 py-1 rounded-sm text-xs font-medium ${
                  eq.status === "Available" ? "bg-success/20 text-success" :
                  eq.status === "In Use" ? "bg-accent/20 text-accent" :
                  eq.status === "Under Maintenance" ? "bg-warning/20 text-warning" :
                  "bg-error/20 text-error"
                }`}>{eq.status}</span>
              </td>
              {isMasterAdmin && (
                <td className="py-3 px-4 text-center">
                  <div className="flex items-center justify-center space-x-2">
                    <button onClick={() => onViewLogHistory(eq)} className="p-1 hover:bg-slate-200 rounded" title="Log History" data-testid={`view-log-history-${eq.id}`}><Clock className="w-4 h-4 text-slate-600" /></button>
                    <button onClick={() => onViewDocuments(eq)} className="p-1 hover:bg-slate-200 rounded" title="Documents"><File className="w-4 h-4 text-accent" /></button>
                    <button onClick={() => onEdit(eq)} className="p-1 hover:bg-slate-200 rounded" title="Edit"><Edit className="w-4 h-4 text-primary" /></button>
                    <button onClick={() => onArchive(eq)} className="p-1 hover:bg-amber-100 rounded" title="Archive (De-hire)"><Archive className="w-4 h-4 text-amber-600" /></button>
                    <button onClick={() => onDelete(eq.id, eq.name)} className="p-1 hover:bg-red-100 rounded" title="Delete"><Trash2 className="w-4 h-4 text-error" /></button>
                  </div>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
      {equipment.length === 0 && (
        <div className="text-center py-12 text-slate-500">
          <Truck className="w-16 h-16 mx-auto mb-4 text-slate-400" />
          No equipment added yet.
        </div>
      )}
    </div>
  );
};

export default EquipmentMasterTab;
